const getStyleMethods =  {
  getThreeD(color) {
    if(!color) color = '#FFFFFF';
    let Dvalue = [50, 3, 15, 3, 15, 3, 15];
    let arrC = this._hex2rgb(color);
    let textShadow = '';

    for (let i = 0; i < 5; i++) {
      // eslint-disable-next-line
      arrC.forEach((val, index, arr) => {
        arr[index] -= Dvalue[i];
        arr[index] < 0 && (arr[index] = 0);
      });
      textShadow += `0 ${i+1}px 0 ${this._rgb2hex(arrC)},`;
    }

    textShadow += '0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15)';
    return {
      color: color,
      textShadow: textShadow
    };
  },
  getInset(color) {
    if(!color) color = '#666666';
    return {
      backgroundColor: color,
      color: 'transparent',
      textShadow: 'rgba(255,255,255,0.5) 0px 3px 3px'
    };
  },
  getDropCenter(color, size = 100) {
    if(!color) color = '#FFFFFF';
    return {
      color: color,
      textShadow: `0 0 ${Math.round(size * 18 / 100)}px rgba(0,0,0,.35)`
    };
  },
  getPopUp(color, size) {
    if(!color) color = '#FFFFFF';
    let Kratio = [9/100, 50/100, 30/100],
      textShadow = '',
      arrC = this._hex2rgb(color),
      newColor;
    // eslint-disable-next-line
    arrC.forEach((val, index, arr) => {
      arr[index] -= 50;
      arr[index] < 0 && (arr[index] = 0);
    });
    newColor = this._rgb2hex(arrC);
    for(let i = 0; i < Math.round(size * Kratio[0]); i++) {
      textShadow += `0 ${i + 1}px 0 ${newColor},`;
    }
    textShadow += `0 ${Math.round(size * Kratio[1])}px ${Math.round(size * Kratio[2])}px rgba(0,0,0,.3)`;
    return {
      color: color,
      textShadow: textShadow
    };
  },
  getPopLeft(color, size) {
    if(!color) color = '#FFFFFF';
    let Kratio = 8 / 100,
      textShadow = '';
    for(let i = 0; i < Math.round(size * Kratio); i++) {
      textShadow += `-${i + 1}px 0 0 #555,`;
    }
    return {
      color: color,
      textShadow: textShadow.slice(0,-1)
    };
  },
  getPopRight(color, size) {
    if(!color) color = '#FFFFFF';
    let Kratio = 8 / 100,
      textShadow = '';
    for(let i = 0; i < Math.round(size * Kratio); i++) {
      textShadow += `${i + 1}px 0 0 #555,`;
    }
    return {
      color: color,
      textShadow: textShadow.slice(0,-1)
    };
  },
  getFlatSimple(color, size=100) {
    if(!color) color = '#F1EBE5';
    let Dvalue = [45, 54, 72];
    let arrC = this._hex2rgb(color);
    // eslint-disable-next-line
    arrC.forEach((val, index, arr) => {
      arr[index] -= Dvalue[index];
      arr[index] < 0 && (arr[index] = 0);
    });
    return {
      color: color,
      textShadow: `0 ${Math.round(size * 13.36 / 100)}px ${Math.round(size * 8.896 / 100)}px ${this._rgb2hex(arrC)}, 0 -2px 1px #fff`
    };
  },
  getGlitch(color) {
    if(!color) color = '#000000';
    return {
      color: color
    };
  },
  getGlitchRed(color) {
    if(!color) color = '#000000';
    return {
      color: color
    };
  },
  getGradenGoldenrod(color, size) {
    let col = ['goldenrod', 'orangered', 'mediumblue', 'purple'];
    if(!color) color = '#FFFF00';
    return this._getGraden(size, col, color);
  },
  getGradenPink(color, size) {
    let col = ['pink', 'orangered', 'red', 'magenta'];
    if(!color) color = '#FFB6C1';
    return this._getGraden(size, col, color);
  },
  getGradenAzure(color, size) {
    let col = ['azure', 'aqua', 'dodgerblue', 'blue'];
    if(!color) color = '#F0FFFF';
    return this._getGraden(size, col, color);
  },
  getGradenTomato(color, size) {
    let col = ['orangered', 'firebrick', 'maroon', 'darkred'];
    if(!color) color = '#FF6347';
    return this._getGraden(size, col, color);
  },
  getGradenYellow(color, size) {
    let col = ['yellow', 'lime', 'green', 'darkgreen'];
    if(!color) color = '#FFFF00';
    return this._getGraden(size, col, color);
  },
  getGradenLightyellow(color, size) {
    let col = ['yellow', 'gold', 'orange', 'darkred'];
    if(!color) color = '#FFFFE0';
    return this._getGraden(size, col, color);
  },
  _getGraden(size, col, color) {
    let basis = Math.round(10 / 100 * size);
    return {
      textShadow: `0 0 ${basis}px ${col[0]}, 0 0 ${basis*2}px ${col[1]}, 0 0 ${basis*4}px ${col[2]}, 0 0 ${basis*8}px ${col[3]}`,
      // filter: 'saturate(60%)',
      color: color
    };
  },
  _hex2rgb: function(hex = '#fff') {
    let arr = [];
    hex = hex.toLowerCase();
    if(hex.length === 4) {
      let shex = '#';
      for(let i=1; i<4; i+=1){  
        shex += hex.slice(i,i+1).concat(hex.slice(i,i+1));     
      }  
      hex = shex;  
    }
    for(let i=1; i<7; i+=2) {
      arr.push(parseInt('0x' + hex.slice(i, i+2)));
    }
    return arr;
  },
  _rgb2hex: function(arr) {
    return '#' + ((1 << 24) + (arr[0] << 16) + (arr[1] << 8) + arr[2] << 0).toString(16).slice(1);
  }
};

const artPlayMethods = {
  linear: function (t, b, c, d) {
    return c * (t / d) + b;
  },
  getColorChange: function (color,color1) {
    if(!color) color = '#000';
    let rgb = this._hex2rgb(color),
      rgb1 = this._hex2rgb(color1);
    return [
      ...rgb, ...rgb1, rgb1[0] - rgb[0], rgb1[1] - rgb[1], rgb1[2] - rgb[2]
    ];
  },
  GlitchInitEffect: function (dom, control, color) {
    if (!color) color = ['#0ff', '#f0f'];
    let textDom = dom.firstElementChild;
    // let styleName = new Set(['font', 'text-decoration', 'text-align', 'word-break', 'letter-spacing', 'width', 'writing-mode', 'height', 'text-shadow']);
    control[0] = textDom.cloneNode(true);
    // let styles = window.getComputedStyle(textDom, '');
    // for (let i = 0; i<styles.length; i++) {
    //   let name = styles[i];
    //   if(styleName.has(name)) {
    //     control[0].style[name] = styles.getPropertyValue(name);
    //   }
    // }
    control[0].style.position = 'absolute';
    control[0].style.top = 0;
    control[0].style.left = 0;
    control[0].style.opacity = .8;
    control[0].style.color = color[0];
    control[0].style.zIndex = -1;
    control[1] = textDom.cloneNode(true);
    // for (let i = 0; i<styles.length; i++) {
    //   control[1].style[styles[i]] = styles.getPropertyValue(styles[i]);
    // }
    control[1].style.position = 'absolute';
    control[1].style.top = 0;
    control[1].style.left = 0;
    control[1].style.opacity = .8;
    control[1].style.color = color[1];
    control[1].style.zIndex = -2;
    dom.appendChild(control[0]);
    dom.appendChild(control[1]);
  },
  GlitchPlay: function (data, control, frame, frameRate) {
    let transform = {x: 0, y: 0};
    let range = 5 / 100 * data.size;
    let time = frame / frameRate % .3;
    let eve = .3 * frameRate / 5;
    frame %= eve;
    if(time >= 0 && time < 0.06) {
      transform.x = this.linear(frame, 0, -range, eve);
      transform.y = this.linear(frame, 0, range, eve);
    }else if(time < 0.12) {
      transform.x = -range;
      transform.y = this.linear(frame, range, -2 * range, eve);
    }else if(time < 0.18) {
      transform.x = this.linear(frame, -range, 2 * range, eve);
      transform.y = transform.x;
    }else if(time < 0.24) {
      transform.x = range;
      transform.y = this.linear(frame, range, -2 * range, eve);
    }else if(time <= 0.3) {
      transform.x = this.linear(frame, range, -range, eve);
      transform.y = this.linear(frame, -range, range, eve);
    }
    control[0].style.transform = `translate(${transform.x}px, ${transform.y}px)`;
    control[1].style.transform = `translate(${-transform.x}px, ${-transform.y}px)`;
  },
  GlitchRedInitEffect: function (dom, control) {
    let color = ['rgba(227, 6, 19)', 'rgba(0, 159, 227)'];
    this.GlitchInitEffect(dom, control, color);
  },
  GlitchRedPlay: function (data, control, frame, frameRate) {
    this.GlitchPlay(data, control, frame, frameRate);
  },
  GradenInitEffect: function(dom, control) {
    control[0] = dom.firstElementChild;
  },
  GradenPlay: function (data, control, frame, frameRate) {
    let trans = {x: 0, y: 0};
    let time = frame / frameRate % 1;
    let colorC = this.getColorChange(data.color, '#fff');
    let arr = [];
    frame %= (frameRate / 2);
    if(time >= 0 && time < 0.5) {
      trans.x = this.linear(frame, 60, 120, frameRate / 2);
      trans.y = this.linear(frame, 0, 20, frameRate / 2);
      arr[0] = this.linear(frame, colorC[0], colorC[6], frameRate / 2);
      arr[1] = this.linear(frame, colorC[1], colorC[7], frameRate / 2);
      arr[2] = this.linear(frame, colorC[2], colorC[8], frameRate / 2);
    } else {
      trans.x = this.linear(frame, 200, -120, frameRate / 2);
      trans.y = this.linear(frame, 20, -20, frameRate / 2);
      arr[0] = this.linear(frame, colorC[3], -colorC[6], frameRate / 2);
      arr[1] = this.linear(frame, colorC[4], -colorC[7], frameRate / 2);
      arr[2] = this.linear(frame, colorC[5], -colorC[8], frameRate / 2);
    }
    control[0].style.color = this._rgb2hex(arr);
    control[0].style.filter = `saturate(${trans.x}%) hue-rotate(${trans.y}deg) ${control[1] || ''}`;
  },
  GradenGoldenrodInitEffect: function(ps, control) {
    this.GradenInitEffect(ps, control);
  },
  GradenGoldenrodPlay: function (data, control, frame, frameRate) {
    this. GradenPlay(data, control, frame, frameRate);
  },
  GradenPinkInitEffect: function(ps, control) {
    this.GradenInitEffect(ps, control);
  },
  GradenPinkPlay: function (data, control, frame, frameRate) {
    this. GradenPlay(data, control, frame, frameRate);
  },
  GradenAzureInitEffect: function(ps, control) {
    this.GradenInitEffect(ps, control);
  },
  GradenAzurePlay: function (data, control, frame, frameRate) {
    this. GradenPlay(data, control, frame, frameRate);
  },
  GradenTomatoInitEffect: function(ps, control) {
    this.GradenInitEffect(ps, control);
  },
  GradenTomatoPlay: function (data, control, frame, frameRate) {
    this. GradenPlay(data, control, frame, frameRate);
  },
  GradenYellowInitEffect: function(ps, control) {
    this.GradenInitEffect(ps, control);
  },
  GradenYellowPlay: function (data, control, frame, frameRate) {
    this. GradenPlay(data, control, frame, frameRate);
  },
  GradenLightyellowInitEffect: function(ps, control) {
    this.GradenInitEffect(ps, control);
  },
  GradenLightyellowPlay: function (data, control, frame, frameRate) {
    this. GradenPlay(data, control, frame, frameRate);
  },
  _hex2rgb: function(hex) {
    let arr = [];
    hex = hex.toLowerCase();
    if(hex.length === 4) {
      let shex = '#';
      for(let i=1; i<4; i+=1){
        shex += hex.slice(i,i+1).concat(hex.slice(i,i+1));
      }
      hex = shex;
    }
    for(let i=1; i<7; i+=2) {
      arr.push(parseInt('0x' + hex.slice(i, i+2)));
    }
    return arr;
  },
  _rgb2hex: function(arr) {
    return '#' + ((1 << 24) + (arr[0] << 16) + (arr[1] << 8) + arr[2] << 0).toString(16).slice(1);
  }
};

function getArtStyle(artType, color, size) {
  if(!artType) return;
  return getStyleMethods['get' + artType](color, size);
}
function artTextInit (type, ps, control) {
  artPlayMethods[type + 'InitEffect'] && artPlayMethods[type + 'InitEffect'](ps, control);
}
function artTextPlay (type, data, control, frame, frameRate) {
  artPlayMethods[type + 'Play'] && artPlayMethods[type + 'Play'](data, control, frame, frameRate);
}
export {
  getArtStyle,
  artTextInit,
  artTextPlay
};



// WEBPACK FOOTER //
// ./src/components/draftPreview/artPlay.js